"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NestedProjectExplorer = void 0;
var data_structures_1 = require("@tableau/data-structures");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var DestinationItem_1 = require("./DestinationItem");
var DestinationTreeItemHelper_1 = require("./DestinationTreeItemHelper");
var NestedItemsFractalRowStore_1 = require("./NestedItemsFractalRowStore");
var TreeViewComponent_1 = require("./TreeViewComponent");
var NestedProjectExplorerCell_1 = require("./dataGridCells/NestedProjectExplorerCell");
function filterProjects(array, text) {
    var personalSpace = undefined;
    var textLowerCase = text.toLocaleLowerCase();
    var nodeReducer = function (result, tree) {
        if (tree.node.name.toLocaleLowerCase().includes(textLowerCase)) {
            if (tree.node.itemType === DestinationItem_1.DestinationItemType.personalSpace) {
                personalSpace = tree;
            }
            else {
                result.push(tree);
            }
        }
        else if (Array.isArray(tree.children)) {
            var matchingChildren = tree.children.reduce(nodeReducer, []);
            if (matchingChildren.length) {
                result.push(new data_structures_1.RoseTree(tree.node, matchingChildren));
            }
        }
        return result;
    };
    var filteredTree = array.reduce(nodeReducer, []);
    return { filteredTree: filteredTree, personalSpace: personalSpace };
}
function buildRowStore(items, topLevelDestinationStatus, rowExpansionHandler, filterText) {
    var _a = filterProjects(items, filterText), filteredTree = _a.filteredTree, personalSpace = _a.personalSpace;
    var filterTextLowerCase = filterText.toLocaleLowerCase();
    var topLevelTrees = [];
    if (personalSpace) {
        topLevelTrees.push(personalSpace);
    }
    var site = NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.topLevelItemContainerForProjects(topLevelDestinationStatus);
    if (filteredTree.length || site.name.toLocaleLowerCase().includes(filterTextLowerCase)) {
        var siteItemTree = new data_structures_1.RoseTree(site, filteredTree);
        topLevelTrees.push(siteItemTree);
    }
    var rowStore = new NestedItemsFractalRowStore_1.NestedItemsFractalRowStore(topLevelTrees, rowExpansionHandler);
    if (filterText) {
        // expand the ancestors of all matches so they're visible.
        // 2023-12-07 ckovatch: not ideal that we're traversing once to filter and again-traversing the filtered tree, but it's necessary because the expanded
        // item hierarchy is RowStore state, not project tree state. real-world perf seems acceptable so not gonna fuss over it.
        var listOfMatchingIds = filteredTree.flatMap(function (t) { return t.fold(function (list, node) {
            if (node.name.toLocaleLowerCase().includes(filterTextLowerCase)) {
                list.push(node.id);
            }
            return list;
        }, []); });
        listOfMatchingIds.forEach(function (id) { return rowStore.expandParentsOfItemKey(id); });
    }
    return rowStore;
}
var CellFormatterFactory = (0, NestedProjectExplorerCell_1.getDestinationProjectCellFormatter)();
var LegacyNestedProjectExplorer = /** @class */ (function (_super) {
    __extends(LegacyNestedProjectExplorer, _super);
    function LegacyNestedProjectExplorer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            filterText: '',
            selectedProjectId: _this.props.initiallySelectedProjectId || null,
        };
        _this.rowExpansionHandler = function (rowKey) {
            _this.rowStore.toggleExpansionForItemKey(rowKey);
            _this.forceUpdate();
        };
        _this.rowStore = buildRowStore(_this.props.projects, _this.props.topLevelDestinationStatus, _this.rowExpansionHandler, _this.state.filterText);
        _this.announceTimeoutId = 0;
        _this.handleFilterChange = function (e) { return _this.setState({ filterText: e.target.value }); };
        _this.handleItemClicked = function (newProject) {
            if (newProject.status !== 'valid') {
                return;
            }
            var currentSelectedId = _this.state.selectedProjectId;
            var rowAlreadySelected = currentSelectedId !== null && currentSelectedId === newProject.id;
            if (rowAlreadySelected) {
                _this.setState({ selectedProjectId: null });
                _this.props.onSelectedProjectChanged(null);
            }
            else {
                _this.setState({ selectedProjectId: newProject.id });
                _this.props.onSelectedProjectChanged(newProject);
            }
        };
        return _this;
    }
    LegacyNestedProjectExplorer.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, projects = _a.projects, topLevelDestinationStatus = _a.topLevelDestinationStatus;
        var _b = this.state, filterText = _b.filterText, selectedProjectId = _b.selectedProjectId;
        if (projects !== prevProps.projects || topLevelDestinationStatus !== prevProps.topLevelDestinationStatus || filterText !== prevState.filterText) {
            this.rowStore = buildRowStore(projects, topLevelDestinationStatus, this.rowExpansionHandler, filterText);
            if (!filterText && selectedProjectId) {
                this.rowStore.expandParentsOfItemKey(selectedProjectId);
            }
            this.forceUpdate();
        }
        if (filterText !== prevState.filterText) {
            if (filterText) {
                this.announceOptionCount();
            }
            else {
                window.clearTimeout(this.announceTimeoutId);
            }
        }
    };
    Object.defineProperty(LegacyNestedProjectExplorer.prototype, "matchingProjectCount", {
        get: function () {
            return this.rowStore.getVisibleItemCount();
        },
        enumerable: false,
        configurable: true
    });
    /** Debounced announcement of option count, to avoid reading a new count with every keystroke while the user is still typing. */
    LegacyNestedProjectExplorer.prototype.announceOptionCount = function (timeout) {
        if (timeout === void 0) { timeout = 2000; }
        window.clearTimeout(this.announceTimeoutId); // it's a safe noop to call clearTimeout on an invalid timer id
        var optionCount = this.matchingProjectCount;
        var formattedOptionCount = Localize_1.Formatters.formatCount(optionCount);
        this.announceTimeoutId = window.setTimeout(function () { return widgets_1.LiveAnnouncer.announce(widgets_1.FilteringListMessages.optionCountAnnouncement({ optionCount: optionCount, formattedOptionCount: formattedOptionCount }), 'assertive'); }, timeout);
    };
    LegacyNestedProjectExplorer.prototype.render = function () {
        var _a = this.props, initiallySelectedProjectId = _a.initiallySelectedProjectId, keepParentsOfSelectedItemExpanded = _a.keepParentsOfSelectedItemExpanded, onSelectedProjectChanged = _a.onSelectedProjectChanged, selectRowOnExpansion = _a.selectRowOnExpansion, projects = _a.projects, showSearchField = _a.showSearchField, topLevelDestinationStatus = _a.topLevelDestinationStatus, htmlProps = __rest(_a, ["initiallySelectedProjectId", "keepParentsOfSelectedItemExpanded", "onSelectedProjectChanged", "selectRowOnExpansion", "projects", "showSearchField", "topLevelDestinationStatus"]);
        var treeView = React.createElement(TreeViewComponent_1.TreeViewComponent, { cellFormatter: CellFormatterFactory, keepParentsOfSelectedItemExpanded: keepParentsOfSelectedItemExpanded, onItemClicked: this.handleItemClicked, rowStore: this.rowStore, selectRowOnExpansion: selectRowOnExpansion, selectedItemId: this.state.selectedProjectId });
        if (!showSearchField) {
            return React.cloneElement(treeView, htmlProps);
        }
        return React.createElement("div", __assign({ style: { display: 'flex', gap: 4, flexDirection: 'column', height: '100%', padding: 4, boxSizing: 'border-box' } }, htmlProps),
            React.createElement(widgets_1.TextFieldWidget, { "aria-label": Localize_1.Messages.searchProjects(), kind: 'search', label: '', onChange: this.handleFilterChange, style: { width: '100%' }, testId: '', value: this.state.filterText }),
            !this.state.filterText || this.matchingProjectCount > 0 ? treeView :
                React.createElement("span", { style: { lineHeight: "".concat(TreeViewComponent_1.TreeViewComponent.RowHeight, "px"), textAlign: 'center' } }, widgets_1.FilteringListMessages.noMatches()));
    };
    return LegacyNestedProjectExplorer;
}(React.PureComponent));
var getInitiallyExpandedProjectIds = function (destinationById, initiallySelectedProjectId) {
    var ancestorIds = (0, DestinationTreeItemHelper_1.getAncestorIds)(destinationById, initiallySelectedProjectId);
    return ancestorIds.size ? ancestorIds : new Set([NestedItemsFractalRowStore_1.NestedItemsFractalRowStore.SentinelRootProjectId]); // make sure the root project is expanded initially
};
var NewNestedProjectExplorer = function (props) {
    var initiallySelectedProjectId = props.initiallySelectedProjectId, keepParentsOfSelectedItemExpanded = props.keepParentsOfSelectedItemExpanded, onSelectedProjectChanged = props.onSelectedProjectChanged, selectRowOnExpansion = props.selectRowOnExpansion, projects = props.projects, showSearchField = props.showSearchField, topLevelDestinationStatus = props.topLevelDestinationStatus, htmlProps = __rest(props, ["initiallySelectedProjectId", "keepParentsOfSelectedItemExpanded", "onSelectedProjectChanged", "selectRowOnExpansion", "projects", "showSearchField", "topLevelDestinationStatus"]);
    var mounted = React.useRef(false);
    var treeRef = React.useRef(null);
    var _a = React.useState((0, DestinationTreeItemHelper_1.getDestinationTreeInfo)(projects, topLevelDestinationStatus)), destinationTreeInfo = _a[0], setDestinationTreeInfo = _a[1];
    var initiallyExpandedProjectIds = React.useState(getInitiallyExpandedProjectIds(destinationTreeInfo.destinationById, initiallySelectedProjectId))[0];
    React.useEffect(function () {
        if (!mounted.current) {
            mounted.current = true;
        }
        else { // recompute the tree info for subsequent renders, not the initial render
            setDestinationTreeInfo((0, DestinationTreeItemHelper_1.getDestinationTreeInfo)(projects, topLevelDestinationStatus));
        }
    }, [projects, topLevelDestinationStatus]);
    var handleExpansionChange = React.useCallback(function (id) {
        var destinationItem = destinationTreeInfo.destinationById[id];
        if (!treeRef.current || !destinationItem) {
            return;
        }
        var shouldBecomeSelected = selectRowOnExpansion && treeRef.current.selectedValue !== id && destinationItem.status === 'valid';
        var isAncestorOfSelectedItem = !shouldBecomeSelected && treeRef.current.selectedValue
            && (0, DestinationTreeItemHelper_1.getAncestorIds)(destinationTreeInfo.destinationById, treeRef.current.selectedValue).has(id);
        if (keepParentsOfSelectedItemExpanded && isAncestorOfSelectedItem) {
            var newExpandedValues = new Set(treeRef.current.expandedValues);
            newExpandedValues.add(id);
            treeRef.current.expandedValues = newExpandedValues;
        }
        if (shouldBecomeSelected) {
            treeRef.current.toggleSelection(id, true);
        }
        treeRef.current.activeValue = id;
    }, [destinationTreeInfo.destinationById, keepParentsOfSelectedItemExpanded, selectRowOnExpansion]);
    var handleSelectionChange = React.useCallback(function () {
        window.setTimeout(function () {
            if (!treeRef.current) {
                return;
            }
            onSelectedProjectChanged(treeRef.current.selectedValue ? destinationTreeInfo.destinationById[treeRef.current.selectedValue] : null);
        });
    }, [destinationTreeInfo.destinationById, onSelectedProjectChanged]);
    return React.createElement(widgets_1.TreeWidget, __assign({ "aria-label": Localize_1.Messages.nestedProjectExplorerLabel() }, htmlProps, { children: undefined, hideSearchField: !showSearchField, initiallyExpandedValues: initiallyExpandedProjectIds, initiallySelectedValue: initiallySelectedProjectId, itemFilterFn: DestinationTreeItemHelper_1.destinationTreeItemFilterFn, items: destinationTreeInfo.destinationTreeItems, onExpansionChange: handleExpansionChange, onSelectionChange: handleSelectionChange, style: __assign({ height: '100%', lineHeight: '14px' }, htmlProps.style), testId: 'NestedProjectExplorer', treeRef: treeRef }));
};
var NestedProjectExplorer = /** @class */ (function (_super) {
    __extends(NestedProjectExplorer, _super);
    function NestedProjectExplorer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NestedProjectExplorer.prototype.render = function () {
        var _a = this.props, projects = _a.projects, otherProps = __rest(_a, ["projects"]);
        if (isRoseTreeArray(projects)) {
            return React.createElement(LegacyNestedProjectExplorer, __assign({ projects: projects }, otherProps));
        }
        else {
            return React.createElement(NewNestedProjectExplorer, __assign({ projects: projects }, otherProps));
        }
    };
    NestedProjectExplorer.defaultProps = {
        keepParentsOfSelectedItemExpanded: true,
        selectRowOnExpansion: true,
    };
    return NestedProjectExplorer;
}(React.PureComponent));
exports.NestedProjectExplorer = NestedProjectExplorer;
function isRoseTreeArray(projects) {
    return projects[0] instanceof data_structures_1.RoseTree;
}
//# sourceMappingURL=NestedProjectExplorerComponent.js.map